/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Header show on scrolling back up past threshold
let lastScroll = 0;
let lastScrollBuffer = 0;
let lastScrollDirection = 'down'
let scrollUpClass = 'scroll-up-active';
let scrollUpProgressingClass = 'scroll-up-progressing';
let scrollChangeThreshold = 70;
let articleSidebarHeadingsContainer = document.querySelector('.card-article-sidebar-headings .list-group');

function handleOnWindowScroll() {

    const currentScroll = window.pageYOffset;
    const navbarHeader = document.getElementById('navbar-header');

    if(!navbarHeader) {
        return;
    }

    const navbarHeaderHeight = navbarHeader.offsetHeight;

    if (currentScroll <= navbarHeaderHeight) {

        document.body.classList.remove(scrollUpClass);
        setTimeout(function() {
            document.body.classList.remove(scrollUpProgressingClass);
            document.body.style.paddingTop = '0px';
            navbarHeader.style.top = '-100%';
        }, 35);

        return;

    }


    if (currentScroll > lastScroll) {

        // down

        if( lastScrollDirection == 'up' ) {
            lastScrollBuffer = 0;
        }

        lastScrollDirection = 'down';

        if( lastScrollBuffer == 0 ) {
            lastScrollBuffer = currentScroll;
        } else if( lastScrollBuffer - currentScroll <= -Math.abs(scrollChangeThreshold) && document.body.classList.contains(scrollUpClass) ) {
            document.body.classList.add(scrollUpProgressingClass);
            document.body.style.paddingTop = navbarHeaderHeight + 'px';
            setTimeout(function() {
                document.body.classList.remove(scrollUpClass);
            }, 1);
        }

    } else if (currentScroll < lastScroll) {

        // up

        if( lastScrollDirection == 'down' ) {
            lastScrollBuffer = 0;
        }

        lastScrollDirection = 'up';

        if( lastScrollBuffer == 0 ) {
            lastScrollBuffer = currentScroll;
        } else if( lastScrollBuffer - currentScroll >= Math.abs(scrollChangeThreshold) && !document.body.classList.contains(scrollUpClass) ) {
            document.body.style.paddingTop = navbarHeaderHeight + 'px';
            document.body.classList.add(scrollUpProgressingClass);
            setTimeout(function() {
                document.body.classList.add(scrollUpClass);
            }, 1);
        }

    }

    lastScroll = currentScroll;

}

function initHeaderShowOnScrollUp() {

    window.addEventListener('scroll', handleOnWindowScroll);

}

// initHeaderShowOnScrollUp();

function generateUuid(){
    var dt = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

if(articleSidebarHeadingsContainer) {

    var headingIntersectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {

                // Remove old heading active
                articleSidebarHeadingsContainer.childNodes.forEach((section) => {
                    console.log(section);
                    section.classList.remove('active');
                });

                let link = document.querySelector('[href="#' + entry.target.id + '"]');
                link.classList.add('active');

                console.log(entry.target.innerHTML);

            }
        });
    }, {
        root: window.document,
        threshold: 0,
    },);

    document.querySelectorAll('.page-article-show #article-content h1, .page-article-show #article-content h2, .page-article-show #article-content h3, .page-article-show #article-content h4, .page-article-show #article-content h5').forEach((section) => {

        if(!section.textContent) {
            return;
        }

        const headingUuid = generateUuid();

        /** Add a uuid to the header for easy goto **/
        section.id = headingUuid;

        /** Build the sidebar **/
        let linkElement = document.createElement('a');
        linkElement.href = '#' + headingUuid;

        // Configure the classes
        // liElement.classList.add('list-group-item py-2 small');
        linkElement.classList.add('list-group-item');
        linkElement.classList.add('small');
        linkElement.classList.add('py-2');

        // If first, remove top border
        if(!articleSidebarHeadingsContainer.children.length) {
            linkElement.classList.add('border-top-0');
        }

        // auto indentation
        if(section.tagName.toLowerCase() == 'h3') {
            linkElement.classList.add('pl-3');
        } else if(section.tagName.toLowerCase() == 'h4') {
            linkElement.classList.add('pl-4');
        } else if(section.tagName.toLowerCase() == 'h5') {
            linkElement.classList.add('pl-5');
        } else if(section.tagName.toLowerCase() == 'h6') {
            linkElement.classList.add('pl-6');
        }

        let tagName = section.tagName.toLowerCase().replace("h","pl-");
        linkElement.classList.add(tagName);


        // Add the heading text
        let liTextNode = document.createTextNode(section.textContent);
        linkElement.appendChild(liTextNode);
        articleSidebarHeadingsContainer.appendChild(linkElement);

        /** Begin observing scrolling **/
        headingIntersectionObserver.observe(section);

    });

    if (!articleSidebarHeadingsContainer.children.length) {

        // Hide headings sidebar card
        document.querySelector('.card-article-sidebar-headings').classList.add('d-none');

        // Kill any observer
        headingIntersectionObserver.disconnect();

    } else {

        document.body.classList.add('article-sidebar-active');

    }

}
































































